import { z } from 'zod';

export const JIRA_ACTION_PREVIEW_TITLE_MAX_LENGTH = 200;
export const JIRA_ACTION_PREVIEW_RATIONALE_MAX_LENGTH = 1_000;
export const JIRA_ACTION_PREVIEW_COMMENT_MAX_LENGTH = 5_000;
export const JIRA_ACTION_PREVIEW_SUBTASK_SUMMARY_MAX_LENGTH = 255;
export const JIRA_ACTION_PREVIEW_SUBTASK_DESCRIPTION_MAX_LENGTH = 5_000;
export const JIRA_ACTION_PREVIEW_ISSUE_KEY_MAX_LENGTH = 255;

export const jiraActionTargetSchema = z
  .object({
    itemId: z.number().int().positive(),
    issueKey: z.string().trim().min(1).max(JIRA_ACTION_PREVIEW_ISSUE_KEY_MAX_LENGTH),
  })
  .strict();

const jiraActionPreviewBaseSchema = z.object({
  target: jiraActionTargetSchema,
  title: z.string().trim().min(1).max(JIRA_ACTION_PREVIEW_TITLE_MAX_LENGTH),
  rationale: z.string().trim().min(1).max(JIRA_ACTION_PREVIEW_RATIONALE_MAX_LENGTH),
});

export const jiraAddCommentActionPreviewSchema = jiraActionPreviewBaseSchema
  .extend({
    operation: z.literal('add_comment'),
    payload: z
      .object({
        commentBody: z.string().trim().min(1).max(JIRA_ACTION_PREVIEW_COMMENT_MAX_LENGTH),
      })
      .strict(),
  })
  .strict();

export const jiraCreateSubtaskActionPreviewSchema = jiraActionPreviewBaseSchema
  .extend({
    operation: z.literal('create_subtask'),
    payload: z
      .object({
        summary: z.string().trim().min(1).max(JIRA_ACTION_PREVIEW_SUBTASK_SUMMARY_MAX_LENGTH),
        description: z
          .string()
          .trim()
          .min(1)
          .max(JIRA_ACTION_PREVIEW_SUBTASK_DESCRIPTION_MAX_LENGTH),
      })
      .strict(),
  })
  .strict();

export const jiraTransitionIssueActionPreviewSchema = jiraActionPreviewBaseSchema
  .extend({
    operation: z.literal('transition_issue'),
    payload: z
      .object({
        targetStatusCategory: z.enum(['to_do', 'in_progress', 'done']),
      })
      .strict(),
  })
  .strict();

export const jiraActionPreviewSchema = z.discriminatedUnion('operation', [
  jiraAddCommentActionPreviewSchema,
  jiraCreateSubtaskActionPreviewSchema,
  jiraTransitionIssueActionPreviewSchema,
]);
export type JiraActionPreview = z.infer<typeof jiraActionPreviewSchema>;

export const contentIntelligenceRecommendationMetadataSchema = z
  .object({
    source: z.string().optional(),
    insightId: z.string().optional(),
    signalInstanceId: z.string().optional(),
    jiraActionPreview: jiraActionPreviewSchema.optional(),
  })
  .catchall(z.unknown())
  .nullable();

export type ContentIntelligenceRecommendationMetadata = z.infer<
  typeof contentIntelligenceRecommendationMetadataSchema
>;
